<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div class="user-profile">
    <h1>
      <BaseIcon name="user" />
      {{ user.name }}
      Profile
    </h1>
    <pre>{{ user }}</pre>
  </div>
</template>
